import React from "react";
import { useDrag } from "react-dnd";

export default function FighterCard({ fighter, matchId }) {
  const [{ isDragging }, drag] = useDrag({
    type: "FIGHTER",
    item: { fighter, fromMatchId: matchId }, // must include original match
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={drag}
      className="fighter-card"
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      {fighter.name}
    </div>
  );
}
